var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRestaurant = function SvgRestaurant(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "restaurant_svg__a",
    width: 24,
    height: 25,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 .188h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#restaurant_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.225 21.688a.5.5 0 0 1-.35-.137.47.47 0 0 1-.15-.363v-7.5h-.85q-.65 0-1.125-.476a1.57 1.57 0 0 1-.475-1.15V7.189q0-1.676.938-2.963t2.512-1.487v18.45a.5.5 0 0 1-.138.363.5.5 0 0 1-.362.137m-9.225 0a.5.5 0 0 1-.362-.137.5.5 0 0 1-.138-.363v-8.525A3.26 3.26 0 0 1 5.538 11.6q-.813-.887-.813-2.187V3.188q0-.226.15-.364a.5.5 0 0 1 .35-.136q.225 0 .363.136a.5.5 0 0 1 .137.364v6.224H7.5V3.188q0-.224.15-.362A.5.5 0 0 1 8 2.687q.225 0 .363.138a.5.5 0 0 1 .137.362v6.226h1.775V3.188a.5.5 0 0 1 .138-.364.5.5 0 0 1 .362-.136q.2 0 .35.136.15.14.15.364v6.224q0 1.3-.812 2.188A3.26 3.26 0 0 1 8.5 12.663v8.525a.47.47 0 0 1-.15.363.5.5 0 0 1-.35.137"
  }))));
};
export default SvgRestaurant;